<template>
  <div>
    <template v-if='isPdf'>
      <QPdf :url="previewUrl" v-if="previewDialog" @close="previewDialog = false" />
    </template>
    <template v-else>
      <QImage v-model="previewDialog" :imageUrl="previewUrl" />
    </template>
  </div>
</template>

<script>
import QImage from '@/components/previewHandout/compoments/image.vue'
import QPdf from '@/components/previewHandout/compoments/pdf.vue'
export default {
  components: {
    QImage,
    QPdf
  },
  data() {
    return {
      previewDialog: false,
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    previewUrl: {
      type: String,
      default: ''
    }
  },
  watch: {
    value: function() {
      this.previewDialog = this.value
    },
    previewDialog: function() {
      this.$emit('input', this.previewDialog)
    }
  },
  computed: {
    isPdf: function() {
      return this.previewUrl.toUpperCase().includes('PDF')
    },
    isImage: function() {
      return ['PNG','JPG','JPEG'].some(element => this.previewUrl.toUpperCase().includes(element))
    },
  },
}
</script>
